import React from 'react';
import classnames from 'classnames';

import map from 'lodash/map';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';


const ScrollIndicatorUi_ViewerVersion1 = ({
  currentSubpage,
  submenuItems,
  isMobile,
  isAnchorActiveById,
  scrollIndicatorColorClass,
  onScrollToSubmenuItem
})=> (
  <div className={classnames('scroll-indicator-container', scrollIndicatorColorClass, isMobile ? 'mobile' : 'desktop')} >
    <div className="scroll-indicator">

      <span className="scroll-indicator-background theme-background-color" />

        {
          map(submenuItems, (submenuItem) =>
            <div
              key={submenuItem.id}
              className="scroll-indicator-button-wrapper"
              onClick={() => {
                onScrollToSubmenuItem(currentSubpage, submenuItem);
              }}
            >

              <div className={classnames('scroll-indicator-button', isAnchorActiveById[submenuItem.id] ? 'active' : 'inactive')}>
                <span className="scroll-indicator-button-background theme-background-color" />
              </div>

              <div className="scroll-indicator-button-tooltip theme-background-color theme-color">
                {submenuItem.title} <span className="tooltip-arrow theme-arrow" />
              </div>

            </div>
          )
        }

    </div>
  </div>
);

const ScrollIndicatorUi_ViewerVersion2 = ({
  currentSubpage,
  submenuItems,
  isMobile,
  isAnchorActiveById,
  scrollIndicatorColorClass,
  onScrollToSubmenuItem
})=> (
  <nav
    aria-labelledby="scrollNavLabel"
    className={classnames('scroll-indicator-container', scrollIndicatorColorClass, isMobile ? 'mobile' : 'desktop')}
  >
    <p id="scrollNavLabel" className="visually-hidden">
      Jump to section
    </p>

    <div className="scroll-indicator">

      <span className="scroll-indicator-background theme-background-color" />

        {
          map(submenuItems, (submenuItem) =>
            <button
              key={submenuItem.id}
              className="scroll-indicator-button-wrapper"
              onClick={() => {
                onScrollToSubmenuItem(currentSubpage, submenuItem);
              }}
            >

              <div className={classnames('scroll-indicator-button', isAnchorActiveById[submenuItem.id] ? 'active' : 'inactive')}>
                <span className="scroll-indicator-button-background theme-background-color" />
              </div>

              <div className="visually-hidden scroll-indicator-button-tooltip theme-background-color theme-color">
                { submenuItem.title } <span className="tooltip-arrow theme-arrow"></span>
              </div>

            </button>
          )
        }

    </div>
  </nav>
);

const ScrollIndicatorUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <ScrollIndicatorUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <ScrollIndicatorUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default ScrollIndicatorUi;
